export default "__VITE_ASSET__54c5c856__"